import { createContext } from "react";

import type { ContrastModes } from "@/types/settings";

export interface SettingsValue {
	contrastMode: ContrastModes;
	isSettingsModalOpen: boolean;
	setContrastMode: (contrastMode: ContrastModes) => void;
	setIsSettingsModalOpen: (isSettingsModalOpen: boolean) => void;
}

export const SettingsContext = createContext<null | SettingsValue>(null);
